$(document).ready(function(){
	var autoCompleteJS = new autoComplete({
    selector: "#autoComplete",
    debounce: 300,
    data: {
      src: function(){
        var inputVal = $('input#autoComplete').val();
        var url = window.location.origin + '/' + $('html').attr('lang') + '/json/entries?q=' + inputVal;
        var jqxhr = $.getJSON(url, function(response, statut) {
          // console.log(response);
        });
        return jqxhr;
      },
      key: ["title"]
    },
    resultsList: {
      render: true,
      element: "ul",
      className: "suggestions__list",
      destination: ".suggestions",
      position: "beforeend",
      maxResults: 5,
      container: (element, data) => {
        $('.no_results').hide();
      },
      noResults: (list, query) => {
        setTimeout(function(){
          $('.no_results').fadeIn();
        },300);
      },
      navigation: (event) => {
        $('input#autoComplete').on('keydown', ev => {
          if (ev.key === "Enter") {
            $('form.autoComplete_wrapper').submit();
          }
        });
      },
    },
    resultItem: {
      content: function(data, element) {
        var customElement = '<li class="autoComplete_result" role="option"><a href="'+data.value.url+'"><span>'+data.match+'</span></a></li>';
        $(element).html(customElement);
      },
      highlight: {
        render: true,
        className: "highlighted"
      },
      selected: {
        className: "selected"
      }
    },
  
  });

});